import React from "react";
import { observer } from "mobx-react";
import { TenantStatusCreateStore } from "../../store";
import { TenantStatusCreateForm } from "./TenantStatusCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type TenantStatusCreateProps = {
  tenantStatusCreateStore: TenantStatusCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const TenantStatusCreate: React.FC<TenantStatusCreateProps> = observer(
  ({ tenantStatusCreateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={tenantStatusCreateStore.isSaving} />
        <TenantStatusCreateForm
          tenantStatusCreateStore={tenantStatusCreateStore}
          nameError={tenantStatusCreateStore.errors.name?.message}
          onNameChange={(value: string) => {
            tenantStatusCreateStore.setNameValue(value);
          }}
          name={tenantStatusCreateStore.entityValues.name}
          description_esError={
            tenantStatusCreateStore.errors.description_es?.message
          }
          onDescription_esChange={(value: string) => {
            tenantStatusCreateStore.setDescription_esValue(value);
          }}
          description_es={tenantStatusCreateStore.entityValues.description_es}
          description_enError={
            tenantStatusCreateStore.errors.description_en?.message
          }
          onDescription_enChange={(value: string) => {
            tenantStatusCreateStore.setDescription_enValue(value);
          }}
          description_en={tenantStatusCreateStore.entityValues.description_en}
          description_ptError={
            tenantStatusCreateStore.errors.description_pt?.message
          }
          onDescription_ptChange={(value: string) => {
            tenantStatusCreateStore.setDescription_ptValue(value);
          }}
          description_pt={tenantStatusCreateStore.entityValues.description_pt}
          blocksAccessError={
            tenantStatusCreateStore.errors.blocksAccess?.message
          }
          onBlocksAccessChange={(value: boolean) => {
            tenantStatusCreateStore.setBlocksAccessValue(value);
          }}
          blocksAccess={tenantStatusCreateStore.entityValues.blocksAccess}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={tenantStatusCreateStore.isProcessing}
          onSave={() => tenantStatusCreateStore.saveNewTenantStatus()}
          onCancel={() => tenantStatusCreateStore.cancelNewTenantStatus()}
        />
        <ErrorDialog
          open={tenantStatusCreateStore.errorDialogOpened}
          title={tenantStatusCreateStore.errorTitle}
          description={tenantStatusCreateStore.errorDescription}
          onClose={() => tenantStatusCreateStore.closeErrorDialog()}
        />
      </>
    );
  }
);
